module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/en/1/2-b0a35dbcaebd7f998f6a32e53cdcd5e6.jpg";